import { render, staticRenderFns } from "./NewsTwo.vue?vue&type=template&id=4ac22e96"
import script from "./NewsTwo.vue?vue&type=script&lang=ts"
export * from "./NewsTwo.vue?vue&type=script&lang=ts"
import style0 from "./NewsTwo.vue?vue&type=style&index=0&id=4ac22e96&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports